import clsx from 'clsx';
import { Text } from 'components/UI/Typography/Text';

import styles from './NilPlayerRankingHeaders.module.scss';

export const NilPlayerRankingHeaders = () => {
  return (
    <div className={styles.columnHeaderWrapper}>
      <div className={styles.columnHeaderContainer}>
        <Text
          className={clsx(styles.headerText, styles.rank)}
          variant="subtitle2"
        >
          Rank
        </Text>
        <Text
          className={clsx(styles.headerText, styles.player)}
          variant="subtitle2"
        >
          Player
        </Text>

        <Text
          className={clsx(styles.headerText, styles.social)}
          variant="subtitle2"
        >
          Social
        </Text>
        <Text
          className={clsx(styles.headerText, styles.rating)}
          variant="subtitle2"
        >
          Rating
        </Text>
        <Text
          className={clsx(styles.headerText, styles.status)}
          variant="subtitle2"
        >
          Status
        </Text>

        <Text
          className={clsx(styles.headerText, styles.valuation)}
          variant="subtitle2"
        >
          NIL Valuation /<br /> Roster Value
        </Text>
      </div>
    </div>
  );
};
